/**
 * The shared screen header — title + optional subtitle/meta + right-aligned actions. Uses logical
 * spacing so it mirrors cleanly under dir="rtl".
 */
import type { ReactNode } from "react";

export interface PageHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  meta?: ReactNode;
  actions?: ReactNode;
}

export function PageHeader({ title, subtitle, meta, actions }: PageHeaderProps) {
  return (
    <header
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: "var(--nv-s-4)",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "var(--nv-s-2)" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "var(--nv-s-3)", flexWrap: "wrap" }}>
          <h1 style={{ fontSize: "var(--nv-fs-h1)", margin: 0 }}>{title}</h1>
          {meta}
        </div>
        {subtitle && (
          <p style={{ margin: 0, color: "var(--nv-slate)", fontSize: "var(--nv-fs-body)" }}>
            {subtitle}
          </p>
        )}
      </div>
      {actions && (
        <div style={{ display: "flex", gap: "var(--nv-s-2)", flexWrap: "wrap" }}>{actions}</div>
      )}
    </header>
  );
}
